import PropTypes from "prop-types";
import React, { Component } from "react";

import { OptionShape } from "../../policies/proptypes";

class ComboBox extends Component {
  state = {
    open: false
  };

  toggleDropdown = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  handleSelect = option => {
    const { selectOption } = this.props;
    selectOption(option);
    this.toggleDropdown();
  };

  render() {
    const { open } = this.state;
    const {
      value,
      options,
      selected,
      selectOption,
      onChange,
      onReset,
      ...other
    } = this.props;
    const comboboxItems = options.map(option => (
      <li key={option.key} className="p-list__item">
        <button
          type="button"
          className={`p-button--list ${
            selected === option.key ? "is-selected" : ""
          }`}
          onClick={() => this.handleSelect(option.key)}
        >
          {option.label}
        </button>
      </li>
    ));

    return (
      <div className="p-combo-box p-form__group">
        <input
          type="search"
          className="p-combo-box__input"
          value={value}
          onChange={onChange}
          {...other}
        />
        <button
          type="button"
          className={`p-combo-box__reset u-no-margin--right ${
            value && onReset ? "" : "u-hide"
          }`}
          onClick={onReset}
        >
          <i className="p-icon--close" />
        </button>
        <button
          type="button"
          className="p-combo-box__button"
          onClick={this.toggleDropdown}
        >
          <i className={`p-icon--chevron ${open ? "u-mirror--y" : ""}`} />
        </button>
        {open && (
          <div className="p-combo-box__dropdown">
            <p className="p-combo-box__dropdown-header">Sort by</p>
            <ul className="p-list u-no-margin--bottom">{comboboxItems}</ul>
          </div>
        )}
      </div>
    );
  }
}

ComboBox.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  options: PropTypes.arrayOf(OptionShape).isRequired,
  selected: PropTypes.string,
  selectOption: PropTypes.func.isRequired
};

ComboBox.defaultProps = {
  value: "",
  placeholder: "",
  onReset: undefined,
  selected: undefined
};

export default ComboBox;
